// --- START OF FILE ConfirmationDialog.js ---
// src/components/ConfirmationDialog.js

import React from 'react';
import Modal from 'react-modal';
import styles from './ConfirmationDialog.module.css'; // Create this CSS Module

Modal.setAppElement('#root'); // Ensure this is set somewhere in your app (e.g., index.js)

const ConfirmationDialog = ({ isOpen = true, message, onConfirm, onCancel, isDanger = false }) => {

  // Prevent closing on overlay/esc if actions are pending (not implemented here)
  // For a simple confirmation, allowing close is usually fine, acts as 'Cancel'

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel} // Treat closing as cancelling
      className={styles.modalContent}
      overlayClassName={styles.modalOverlay}
      contentLabel="Confirmation Dialog"
      aria={{ modal: 'true' }}
    >
      <div className={`${styles.dialogContent} ${isDanger ? styles.danger : ''}`}>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button onClick={onConfirm} className={`${styles.button} ${isDanger ? styles.dangerButton : styles.confirmButton}`}>
            Confirm
          </button>
          <button onClick={onCancel} className={`${styles.button} ${styles.cancelButton}`}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;
// --- END OF FILE ConfirmationDialog.js ---